import React from 'react';

export default function Dropbox({ ...props }) {
  return (
    <svg
      width="62"
      height="53"
      viewBox="0 0 62 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M30.7911 10.3648L15.6096 20.1331L30.7911 29.9014L15.6096 39.6697L0.428223 29.8486L15.6096 20.0803L0.428223 10.3648L15.6096 0.596436L30.7911 10.3648ZM15.5311 42.8114L30.7125 33.0431L45.894 42.8114L30.7125 52.5797L15.5311 42.8114ZM30.7911 29.8486L45.9725 20.0803L30.7911 10.3648L45.894 0.596436L61.0754 10.3648L45.894 20.1331L61.0754 29.9014L45.894 39.6697L30.7911 29.8486Z"
        fill="#10284B"
      />
    </svg>
  );
}
